<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="470px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    custom-class="detail-modal"
  >
    是否删除 {{ name }}{{ isPerent ? "以及其子文件" : null }}？
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleOk" v-loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { delFolderFetch } from "../../api/material";
export default {
  data() {
    return {
      visible: false,
      name: "",
      folderId: null,
      loading: false,
      title: null,
      isPerent: false,
    };
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    showModal(node) {
      this.visible = true;
      this.name = node.data.name;
      this.isPerent = node.data.children ? true : false;
      this.folderId = node.data.id;
    },
    handleOk() {
      this.loading = true;
      delFolderFetch({ folderId: this.folderId })
        .then((res) => {
          if (res.code == "0000") {
            this.$message.success("删除成功");
            this.$emit("updateFolder");
            this.visible = false;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
